import { FilterType } from "components/MultiFilter/MultiFilter";
import { useCallback, useEffect, useState, useMemo } from "react";
import { nameSearchFilter } from "utils/filter/filterFields";

/**
 * Custom hook to filter data by multiple columns
 * @param {Array} dataToFilter The data to filter
 * @param {Object} filters The filters to apply
 */
const useFilter = (dataToFilter = [{}], filters) => {
    const [filteredData, setFilteredData] = useState(dataToFilter);

    const filterData = useMemo(() => {
        if (dataToFilter.length === 0 || Object.keys(filters).length === 0) {
            return dataToFilter;
        }

        console.log(filters);

        return dataToFilter.filter(data => {
            return Object.keys(filters).every(filterName => {
                if (!data.hasOwnProperty(filterName)) {
                    return false;
                }

                const dataValue = data[filterName];
                const filterValue = filters[filterName].value;
                const filterType = filters[filterName].filterType;

                console.log(dataValue);
                console.log(filterValue);
                console.log(filterType);

                if (!filterValue || filterValue === "all") {
                    return true;
                }

                switch (filterType) {
                    case FilterType.TEXT:
                    case FilterType.SIMPLE_SELECT:
                        return dataValue.toString().includes(filterValue);
                    case FilterType.TEXT_HYBRID:
                        return nameSearchFilter(dataValue, filterValue);
                    default:
                        return false;
                }
            });
        });
    }, [dataToFilter, filters]);

    useEffect(() => {
        setFilteredData(filterData);
    }, [filterData]);

    return filteredData;
};

export default useFilter;
